export const milestones = [
  { date: 'May 2019',  label: 'We Met',       filled: true,  color: 'blue'   },
  { date: 'Jun 2019',  label: 'First Date',   filled: true,  color: 'pink'   },
  { date: 'Aug 2025',  label: 'Moved In',     filled: true,  color: 'blue'   },
  { date: 'May 2026',  label: 'Engaged 💍',   filled: true,  color: 'purple' },
  { date: 'Aug 2027',  label: 'Wedding 🤍',   filled: false, color: 'future' },
];

export const weddingDate = new Date('2027-08-20T00:00:00');
